import {fromJson, URL_BASE_AUTH} from "../utils/helper.js";


class WorkTicketStaffModel {


    constructor() {

        this.id = null;
        this.work_ticket_id = null;
        this.staff_id = null;
        this.date_id = null;
        this.disp = null;
        this.arriv = null;
        this.dep = null;
        this.tras = null;
        this.trav = null;
        this.toj = null;
        this.hrpc = 'R';
        this.lunch = null;


    }


    static fromJson(object) {
        return fromJson((new WorkTicketStaffModel()), object);
    }

}

export default WorkTicketStaffModel;
